/**
 * Tailwind CSS implementation of Badge component
 * Uses Seeds badge CSS classes from badge.css
 */

import * as React from "react";
import { Icon } from "@sproutsocial/seeds-react-icon";
import type { TypeBadgeProps } from "./BadgeTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

const sizeClasses: Record<string, string> = {
  small: "seeds-badge-sm",
  large: "seeds-badge-lg",
};

export const BadgeTailwind = ({
  children,
  iconName,
  size = "small",
  badgeColor = "blue",
  className,
  ...rest
}: TypeBadgeProps) => {
  const classes = cn(
    "seeds-badge",
    sizeClasses[size] || sizeClasses.small,
    `seeds-badge-${badgeColor}`,
    className
  );

  return (
    <span
      className={classes}
      data-qa-badge
      {...(rest as React.ComponentPropsWithoutRef<"span">)}
    >
      {iconName ? (
        <Icon
          mr={200}
          name={iconName}
          size={size === "small" ? "mini" : "small"}
          aria-hidden
        />
      ) : null}
      {children}
    </span>
  );
};

BadgeTailwind.displayName = "BadgeTailwind";
